import axios from 'axios';
import { useContext } from 'react';
import SnackbarContext from '../../contexts/SnackbarContext';

export const apiBaseUrl = (window.location.href.indexOf('localhost') > -1) ? 'http://localhost:3000/' : 'https://api.tudopets.app/';

export const Api = axios.create({
  baseURL: apiBaseUrl,
  format: 'json'
});

Api.interceptors.request.use(async config => {
  var authentication_token = ""
  var currentUser = JSON.parse(localStorage.getItem('current_user'))

  if(currentUser){
    authentication_token = currentUser.authentication_token;
  }
  if (authentication_token) {
    config.headers['X-User-Token'] = authentication_token
    config.headers['X-User-Email'] = currentUser.email
  }
  return config;
});

Api.interceptors.response.use(
  response => response,
  error => {
    // const { openSnackbar } = useContext(SnackbarContext);
    if (error.response && error.response.data && error.response.data.errors) {
      const errors = error.response.data.errors;
      const errorMessages = Object.keys(errors).map(key => {  
        return errors[key].map(err => `${key} ${err}`).join(', ');
      }).join(', ');
      // console.log(errorMessages, 'error');
      // openSnackbar(errorMessages, 'error');
    } else {
      // openSnackbar(error.message || 'An unexpected error occurred', 'error');
    }
    return Promise.reject(error);
  }
);

